import create from "zustand";

interface TradeState {
  parameters: string | null;
  setParameters: (parameters: string | null) => void;
}

const useTradeStore = create<TradeState>()((set) => ({
  parameters: null,
  setParameters: (parameters: string | null) => set(() => ({ parameters })),
}));

export default useTradeStore;
